import React, { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "@store/store";
import { selectMenuItem } from "@store/menuItem/menuItemReducer";
import { DatePicker } from "@ui-kit/DatePicker/DatePicker";
import dayjs from "dayjs";
import {
  selectDatePickerEndDate,
  selectDatePickerStartDate,
  setDatePickerDateRangeAction,
} from "@store/datePickerReducer";

const EventDateFilter = () => {
  const startDate = useAppSelector(selectDatePickerStartDate);
  const endDate = useAppSelector(selectDatePickerEndDate);
  const dispatch = useAppDispatch();

  const handleDateRangeChange = useCallback(
    (dates: [start: dayjs.Dayjs | null, end: dayjs.Dayjs | null] | null) => {
      dispatch(
        setDatePickerDateRangeAction({
          startDate: dates?.[0]?.toISOString() ?? null,
          endDate: dates?.[1]?.toISOString() ?? null,
        }),
      );
    },
    [dispatch],
  );

  const value = useMemo(():
    | [start: dayjs.Dayjs | null, end: dayjs.Dayjs | null]
    | null => {
    if (!startDate && !endDate) {
      return null;
    }
    return [
      startDate ? dayjs(startDate) : null,
      endDate ? dayjs(endDate) : null,
    ];
  }, [startDate, endDate]);

  const menuItem = useAppSelector(selectMenuItem);

  if (menuItem?.entity !== "Event") {
    return null;
  }

  return <DatePicker value={value} onChange={handleDateRangeChange} />;
};

export { EventDateFilter };
